import { render, staticRenderFns } from "./PrettyBackground.vue?vue&type=template&id=b21e837a&scoped=true&lang=pug&"
import script from "./PrettyBackground.vue?vue&type=script&lang=ts&"
export * from "./PrettyBackground.vue?vue&type=script&lang=ts&"
import style0 from "./PrettyBackground.vue?vue&type=style&index=0&id=b21e837a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e837a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VFadeTransition})
